import React, { FunctionComponent } from 'react';
import t from 'rcm-i18n';

interface Props {
  messages?: any;
}

const MessagesDisplay: FunctionComponent<Props> = (props) => {
  if (props.messages?.length === 0) {
    return null;
  }
  // Only show the first message since subsequent ones may be for individual fields and untranslated/untranslatable
  const messages = [(props.messages || [])[0]];
  return (
    <div>
      {messages.map((message, index) => (
        <div key={index} className={'alert alert-warning'} role="alert">
          <div className="message">{t(message?.value || 'An unknown error occurred.')}</div>
        </div>
      ))}
    </div>
  );
};

export default MessagesDisplay;
